export default __webpack_public_path__ + "static/media/PhoneAndWatch.4f282675.svg";